import { stringify } from 'qs';

import type { ProductListItemType } from '@zoomit/web-kit';
import { ApiManager } from '@zoomit/web-kit';

import { CompareSearch, ProductSearch } from '../../constants/apis';
import type {
  CompareSearchResponse,
  ProductSearchResponse,
  SearchByCategoryParams,
  SearchCompareParams,
  SearchProductsParams,
} from '../../types/search';

export const searchProduct = (params: SearchProductsParams) => {
  return ApiManager.get<ProductSearchResponse>(ProductSearch, {
    params,
    paramsSerializer: (params) => {
      return stringify(params, {
        allowDots: true,
      });
    },
  });
};

export const searchByCategory = (params: SearchByCategoryParams) =>
  ApiManager.get<ProductListItemType[]>(`${ProductSearch}/category`, {
    params,
  });

export const searchCompare = (params: SearchCompareParams) => {
  return ApiManager.get<CompareSearchResponse>(CompareSearch, {
    params,
  });
};
